import {
  apiPmsContract,
  apiV1Contract,
  clinicContract,
  consultationContract,
  consultationNotesHistoryContract,
  documentContract,
  ihiReviewLogContract,
  patientAssessmentContract,
  patientConcessionCardContract,
  patientDetailsContract,
  patientIhiContract,
  patientNotesContract,
  patientPrescriptionContract,
  patientStudiesContract,
} from '@montugroup/pms-api-contracts';
import { prescribeContract, prescriptionContract } from '@montugroup/prescription-contracts';
import { initContract } from '@ts-rest/core';
import { createQueryClient } from './queryClient.util';

const baseContract = initContract();

const mergedContract = baseContract.router({
  clinicContract,
  consultationNotesHistoryContract,
  consultationContract,
  apiV1Contract,
  documentContract,
  ihiReviewLogContract,
  patientNotesContract,
  patientAssessmentContract,
  patientConcessionCardContract,
  patientDetailsContract,
  patientIhiContract,
  patientPrescriptionContract,
  patientStudiesContract,
  apiPmsContract,
  prescribeContract,
  prescriptionContract,
});

export const tsrContractsClient = createQueryClient({
  contract: mergedContract,
});
